export enum ResultPlayer {
    BJRS_NoHand,
    BJRS_PlayerWin,
    BJRS_BankerWin,
    BJRS_Tie,
}
